import { ExamFormEntry, ExamFormState } from '../types';
import { DynamicFormState } from '../../forms/types';

export const determineDynamicFormState = (
  examFormEntry: ExamFormEntry,
): DynamicFormState => {
  const { state } = examFormEntry;

  switch (state) {
    case ExamFormState.OPEN:
      return 'open';
    case ExamFormState.IN_REVIEW:
      return 'reviewing';
    case ExamFormState.FINALIZED:
      return 'final';
    default:
      throw new Error('Unsupported exam form state');
  }
};
